import { useCallback, useRef, useState } from "react";
import brokenImg from "../../assets/broken.png";

type NoticeImageCarouselProps = {
  images: string[];
  alt: string;
};

export function NoticeImageCarousel({ images, alt }: NoticeImageCarouselProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const onScroll = useCallback(() => {
    const container = scrollRef.current;
    if (!container) {
      return;
    }

    const index = Math.round(container.scrollLeft / container.clientWidth);
    setActiveIndex(index);
  }, []);

  if (images.length === 0) {
    return null;
  }

  return (
    <div className="mt-4">
      <div
        ref={scrollRef}
        onScroll={onScroll}
        className="flex overflow-x-auto snap-x snap-mandatory [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden"
      >
        {images.map((image, index) => (
          <div
            key={`${image}-${index}`}
            className="flex aspect-square w-full shrink-0 snap-center items-center justify-center rounded-md bg-base-200/40"
          >
            <img
              src={`${image}?type=e1920`}
              alt={alt}
              className="max-h-full max-w-full object-contain rounded-md"
              onError={(e) => {
                e.currentTarget.src = brokenImg;
                e.currentTarget.onerror = null;
              }}
            />
          </div>
        ))}
      </div>
      {images.length > 1 && (
        <div className="flex justify-center gap-1.5 mt-2">
          {images.map((image, index) => (
            <span
              key={`dot-${image}-${index}`}
              className={`size-1.5 rounded-full ${
                index === activeIndex ? "bg-primary" : "bg-base-300"
              }`}
              aria-hidden
            />
          ))}
        </div>
      )}
    </div>
  );
}
